import GraficoLocalService from './graficos/graficos-local.service';
import GraficosDetailCtrl from './graficos/graficos-detail.controller';
import GraficosBaseCtrl from './graficos/graficos-base.controller';
import GraficosMenuDirective from './graficos/menu/graficos-menu.directive';
import GraficosMenuCtrl from './graficos/menu/graficos-menu.controller';
import GraficoDirective from './graficos/grafico/grafico.directive';
import GraficoDirectiveCtrl from './graficos/grafico/grafico.controller';
import FiltrosActivosService from './graficos/filtros/filtros-activos.service';
import FiltrosCacheService from './graficos/filtros/filtros-cache.service';
import FiltrosGraficoCtrl from './graficos/filtros/graficos-filtros.controller';
import FiltrosGraficoDirective from './graficos/filtros/graficos-filtros.directive';
import InformeActionsService from './informes/informes-actions.service';
import DialogInformesAddCtrl from './informes/add/dialog-informes-add.controller';
import DialogInformesCompartirCtrl from './informes/compartir/dialog-informes-compartir.controller';
import InformeViewCtrl from './informes/informe-view/informe-view.controller';
import InformeViewDirective from './informes/informe-view/informe-view.directive';
import InformeRestService from './informes/servicios/informes-rest.service';
import ngResourceModuleName from 'angular-resource';
import nvd3ModuleName from 'angular-nvd3';
import DialogInformesAddAInformeCtrl from "./informes/add-a-informe/dialog-informes-add-a-informe.controller";

const EstadisticasModule = angular
    .module('estadisticas', ['app', nvd3ModuleName, ngResourceModuleName])
    .config(GraficosStatesConfig)
    .factory('GraficoLocalService', GraficoLocalService)
    .controller('GraficosDetailCtrl', GraficosDetailCtrl)
    .controller('GraficosBaseCtrl', GraficosBaseCtrl)
    .directive('graficosMenu', GraficosMenuDirective)
    .controller('GraficosMenuCtrl', GraficosMenuCtrl)
    .directive('grafico', GraficoDirective)
    .controller('GraficoDirectiveCtrl', GraficoDirectiveCtrl)
    .factory('FiltrosActivos', FiltrosActivosService)
    .factory('FiltrosCache', FiltrosCacheService)
    .controller('FiltrosGraficoCtrl', FiltrosGraficoCtrl)
    .directive('filtros', FiltrosGraficoDirective)
    .service('InformeActionsService', InformeActionsService)
    .controller('DialogInformesAddCtrl', DialogInformesAddCtrl)
    .controller('DialogInformesCompartirCtrl', DialogInformesCompartirCtrl)
    .controller('InformeViewCtrl', InformeViewCtrl)
    .directive('informeView', InformeViewDirective)
    .service('InformeRest', InformeRestService)
    .controller('DialogInformesAddAInformeCtrl', DialogInformesAddAInformeCtrl)
;

/**
 * Configuración de las rutas generales
 */
GraficosStatesConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

function GraficosStatesConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('graficos', {
            url: "/",
            abstract: true,
            views: {
                '': {
                    template: require('./graficos/graficos-base.html'),
                    controller: 'GraficosBaseCtrl as vm'
                },
                'menu@graficos': {
                    template: '<graficos-menu></graficos-menu>'
                }
            }
        })
        .state('graficos.detail', {
            url: "detail/:id",
            template: require('./graficos/graficos-detail.html'),
            controller: 'GraficosDetailCtrl as vm'
        });

    $urlRouterProvider.otherwise('/detail/1');
}

export default EstadisticasModule;